var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-sm channel-pill",style:(_vm.pillStyle),attrs:{"type":"button","title":`Show only calls from ${_vm.channel}`},on:{"click":function($event){return _vm.$emit('click', _vm.channel)}}},[_c('strong',[_vm._v(_vm._s(_vm.channel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }